const hi = {
  common: {
    loading: 'लोड हो रहा है...',
    error: 'कुछ गलत हो गया',
    cancel: 'रद्द करें',
    save: 'सहेजें',
    saving: 'सहेज रहे हैं...',
    copy: 'कॉपी',
    copied: 'कॉपी हो गया!',
    goHome: 'होम जाएं',
    back: 'वापस',
    playAudyn: 'Audyn खेलें',
    reload: 'रीलोड',
    or: 'या',
    you: 'आप',
    vs: 'बनाम',
    songs: 'गाने',
    tracks: 'ट्रैक',
    score: 'स्कोर',
    rank: 'रैंक',
    correct: 'सही',
    accuracy: 'सटीकता',
    today: 'आज',
    daily: 'दैनिक',
    streak: 'स्ट्रीक',
    profile: 'प्रोफ़ाइल',
    guest: 'अतिथि',
  },

  nav: {
    dailyChallenge: 'दैनिक चुनौती',
    leaderboard: 'लीडरबोर्ड',
    profile: 'प्रोफ़ाइल',
    logIn: 'लॉग इन',
  },

  home: {
    title: 'गाना पहचानो',
    subtitle: 'Spotify प्लेलिस्ट पेस्ट करें। क्लिप सुनें। गाना बताएं।',
    playersToday: 'आज {count} खिलाड़ी',
    playlistInput: 'https://open.spotify.com/playlist/...',
    loadPlaylist: 'प्लेलिस्ट लोड करें',
    tryDemo: 'डेमो आज़माएं — Today\'s Top Hits',
    recentlyPlayed: 'हाल ही में सुना',
    featuredPlaylists: 'लोकप्रिय प्लेलिस्ट',
    songs: 'गाने',
    difficulty: 'कठिनाई',
    gameMode: 'गेम मोड',
    guessMode: 'अनुमान मोड',
    clips: 'क्लिप',
    startGame: 'खेल शुरू करें',
    challengeFriend: '⚔️ दोस्त को चुनौती दें',
    changePlaylist: 'प्लेलिस्ट बदलें',
    playableTracks: '{count} बजाने योग्य ट्रैक',
    playableOfTotal: '{total} में से {playable} ट्रैक बजाने योग्य',
    allGuessable: 'सभी {total} अनुमान सूची में हैं',
    loadingPreviews: 'प्रीव्यू लोड हो रहे हैं…',
    back: 'वापस',
    backToPlaylist: 'प्लेलिस्ट चयन पर वापस जाएं',

    beatScore: '⚔️ {username} का स्कोर {score} को हराएं!',

    announcement: {
      title: '🎉 अब बड़ी प्लेलिस्ट सपोर्ट करती है!',
      message: '100+ गानों वाली प्लेलिस्ट अब सपोर्टेड हैं। लोड होने में थोड़ा समय लग सकता है।',
    },

    easy: 'आसान',
    easyDesc: 'लंबी क्लिप, सोचने का ज़्यादा समय',
    normal: 'सामान्य',
    normalDesc: 'क्लासिक अनुभव',
    hard: 'कठिन',
    hardDesc: 'पलक झपकते ही छूट जाएगा',
    classic: 'क्लासिक',
    classicDesc: 'केवल क्लिप स्टेज से स्कोर। कोई समय दबाव नहीं।',
    tickingAway: 'टिकिंग अवे',
    tickingAwayDesc: 'जितना समय लगेगा, स्कोर उतना कम। हर सेकंड मायने रखता है।',
    songTitle: 'गाने का नाम',
    songTitleDesc: 'ट्रैक का नाम बताएं',
    artist: 'कलाकार',
    artistDesc: 'कलाकार का नाम बताएं',
  },

  game: {
    tapToBegin: 'शुरू करने के लिए टैप करें',
    tapToUnlock: 'ऑडियो अनलॉक करने के लिए कहीं भी टैप करें',
    listening: 'सुन रहे हैं...',
    ready: 'तैयार',
    tapReplay: 'दोबारा सुनें',
    loadingAudio: 'लोड हो रहा है...',
    skipped: 'छोड़ दिया',
    audioError: 'ऑडियो त्रुटि',
    typeGuess: 'अपना अनुमान टाइप करें...',
    typeArtist: 'कलाकार का नाम टाइप करें...',
    checking: 'जाँच रहे हैं...',
    skip: 'छोड़ें',
    timePressure: 'समय दबाव',
    nextSong: 'अगला गाना',
    seeResults: 'परिणाम देखें',
    betterLuck: 'अगली बार बेहतर किस्मत',
    correctArtist: 'सही कलाकार!',
    theArtistWas: 'कलाकार था: {artist}',
    openInSpotify: 'Spotify में खोलें',
    base: 'आधार',
    timePenalty: 'समय दंड',
    streakMultiplier: '× {mult} स्ट्रीक',
    kbPlay: '[Space] चलाएं',
    kbGuess: '[Enter] अनुमान',
    kbClear: '[Esc] साफ़',
  },

  end: {
    newPersonalBest: '🏆 नया व्यक्तिगत सर्वश्रेष्ठ!',
    copyLink: 'लिंक कॉपी करें',
    copyShareText: 'शेयर टेक्स्ट कॉपी करें',
    challengeFriend: 'दोस्त को चुनौती दें',
    copyManually: 'मैन्युअल कॉपी करें:',
    playAgain: 'फिर से खेलें',
    newPlaylist: 'नई प्लेलिस्ट',
    viewLeaderboard: 'लीडरबोर्ड देखें',
    createAccount: 'स्कोर सेव करने और बैज अर्जित करने के लिए अकाउंट बनाएं',
    signUp: 'साइन अप',
    outOf: '{max} में से',
    missedTracks: 'छूटे हुए ट्रैक',
    scoreCard: 'स्कोर कार्ड',
    shareText: 'मैंने {playlist} पर {score}/{max} स्कोर किया 🎵 ({difficulty} • {tracks} गाने) — क्या आप मुझे हरा सकते हैं? {link}',
  },

  daily: {
    title: 'दैनिक चुनौती',
    todaysChallenge: 'आज की चुनौती',
    classicMode: '🎵 क्लासिक मोड • कोई समय दबाव नहीं',
    playToday: 'आज की चुनौती खेलें',
    alreadyPlayed: '✅ आपने आज की चुनौती पूरी कर ली है',
    signInToSave: 'दैनिक स्ट्रीक सेव करने के लिए साइन इन करें',
    firstDay: 'पहला दिन! जारी रखें।',
    dayStreak: '{count}-दिन स्ट्रीक',
    couldNotLoad: 'दैनिक चुनौती लोड नहीं हो सकी',
    needsCache: 'दैनिक प्लेलिस्ट को कैश भरने के लिए एक बार चलाना होगा।',
    alreadyPlayedToast: 'आपने आज की चुनौती पहले ही खेल ली है!',
  },

  leaderboard: {
    title: 'लीडरबोर्ड',
    global: '🏆 वैश्विक',
    daily: '📅 दैनिक',
    allTime: 'सर्वकालिक',
    month: 'महीना',
    week: 'सप्ताह',
    noEntries: 'अभी कोई प्रविष्टि नहीं',
    beFirst: 'खेलें और अपनी जगह बनाएं!',
    yourRank: 'आपकी रैंक',
    rankedByTimePressure: 'समय दबाव में स्कोर के अनुसार रैंक',
    classicMode: '🎵 क्लासिक',
    tickingMode: '⏱️ टिकिंग अवे',
    songMode: '🎵 गाने का नाम',
    artistMode: '🎤 कलाकार',
  },

  login: {
    title: 'लॉग इन',
    email: 'ईमेल',
    emailPlaceholder: 'you@example.com',
    password: 'पासवर्ड',
    passwordPlaceholder: '••••••••',
    logInBtn: 'लॉग इन',
    signingIn: 'साइन इन हो रहा है...',
    noAccount: 'अकाउंट नहीं है?',
    signUpLink: 'साइन अप करें',
    welcomeBack: 'वापसी पर स्वागत!',
    fillFields: 'कृपया सभी फ़ील्ड भरें',
    loginFailed: 'लॉगिन विफल',
  },

  register: {
    title: 'साइन अप',
    saveProgress: 'अपनी प्रगति सेव करें',
    saveProgressDesc: 'लीडरबोर्ड पर स्कोर रखने के लिए अकाउंट बनाएं।',
    username: 'यूज़रनेम',
    usernamePlaceholder: 'your_username',
    email: 'ईमेल',
    emailPlaceholder: 'you@example.com',
    password: 'पासवर्ड',
    passwordPlaceholder: 'कम से कम 8 अक्षर',
    bio: 'बायो',
    bioPlaceholder: 'अपने बारे में कुछ...',
    optional: 'वैकल्पिक',
    createAccount: 'अकाउंट बनाएं',
    saveAccount: 'अकाउंट सेव करें',
    creating: 'बना रहे हैं...',
    haveAccount: 'पहले से अकाउंट है?',
    logInLink: 'लॉग इन',
    welcomeToAudyn: 'Audyn में आपका स्वागत है!',
    accountCreated: 'अकाउंट बन गया! आपके स्कोर सुरक्षित रहेंगे।',
    fillRequired: 'कृपया सभी आवश्यक फ़ील्ड भरें',
    passwordMin: 'पासवर्ड कम से कम 8 अक्षरों का होना चाहिए',
    registrationFailed: 'पंजीकरण विफल',
  },

  profile: {
    title: 'प्रोफ़ाइल',
    editProfile: 'प्रोफ़ाइल संपादित करें',
    displayName: 'प्रदर्शित नाम',
    displayNamePlaceholder: 'प्रदर्शित नाम (वैकल्पिक)',
    displayNameHint: '{count}/50 — यूज़रनेम दिखाने के लिए खाली छोड़ें',
    bioPlaceholder: 'एक छोटा बायो लिखें...',
    spotify: 'Spotify',
    spotifyPlaceholder: 'https://open.spotify.com/user/your_id',
    spotifyError: 'https://open.spotify.com/user/ से शुरू होना चाहिए',
    instagram: 'Instagram',
    instagramError: 'केवल अक्षर, अंक, अंडरस्कोर और पीरियड (1–30 अक्षर)',
    pinterest: 'Pinterest',
    pinterestError: 'केवल अक्षर, अंक, अंडरस्कोर और पीरियड (3–30 अक्षर)',
    achievements: 'उपलब्धियाँ',
    playToEarn: 'उपलब्धियाँ अर्जित करने के लिए खेलें!',
    recentScores: 'हालिया स्कोर',
    profileUpdated: 'प्रोफ़ाइल अपडेट हो गई',
    avatarUpdated: 'अवतार अपडेट हो गया',
    profileLinkCopied: 'प्रोफ़ाइल लिंक कॉपी हो गया!',
    signInToView: 'प्रोफ़ाइल देखने के लिए साइन इन करें',
    onlyJpgPngWebp: 'केवल JPEG, PNG, या WebP',
  },

  publicProfile: {
    userNotFound: 'उपयोगकर्ता नहीं मिला',
    userNotExist: 'यह उपयोगकर्ता मौजूद नहीं है।',
  },

  share: {
    shareNotFound: 'शेयर नहीं मिला',
    shareExpired: 'यह शेयर लिंक समाप्त हो गया है या मौजूद नहीं है।',
    playThisPlaylist: 'यह प्लेलिस्ट खेलें',
    goToAudyn: 'Audyn पर जाएं',
  },

  room: {
    roomCode: 'रूम कोड',
    waitingForOpponent: 'प्रतिद्वंद्वी का इंतज़ार...',
    shareCodeHint: 'कोड या लिंक शेयर करें। रूम 30 मिनट में समाप्त होगा।',
    cancelRoom: 'रद्द करें',
    opponent: 'प्रतिद्वंद्वी',
    playAgain: 'फिर से खेलें',
    wonBy: 'आपने {diff} अंकों से जीता! 🏆',
    tie: 'बराबरी!',
    lostBy: 'आप {diff} अंकों से हारे',
    h2hChallenge: 'आमने-सामने चुनौती',
    roomLinkCopied: 'रूम लिंक कॉपी हो गया!',
    challengeLinkCopied: 'चुनौती लिंक कॉपी हो गया! दोस्त को भेजें।',
    noPlaylist: 'कोई प्लेलिस्ट नहीं चुनी — पहले प्लेलिस्ट लोड करें।',
  },

  errorBoundary: {
    title: 'कुछ गलत हो गया।',
    message: 'फिर से प्रयास करने के लिए पेज रीलोड करें।',
    reload: 'रीलोड',
  },

  languages: {
    en: 'English',
    hi: 'हिन्दी',
    es: 'Español',
    ja: '日本語',
    ko: '한국어',
  },
};

export default hi;
